/**
 * @desc 导出车辆列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.CompanyVehicleInformation): Promise<BaseResponse<any>> {
  return fetch({
    url: config.API_HOST + '/base/vehicle/export',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
